import { QuestionCircle } from 'react-bootstrap-icons';
import { QuestionCircleFill } from 'react-bootstrap-icons';
import { useState } from 'react';

import './Help.css';
import HelpPanel from './HelpPanel';

const Help = ({ category }) => {
    const [show, setShow] = useState(false);
    const [hover, setHover] = useState(false);
    const open = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setShow(true);
    };
    const close = (event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        setShow(false);
    };

    return <>
            <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                {!hover && <QuestionCircle className="me-2 help-icon" onClick={open} />}
                {hover && <QuestionCircleFill className="me-2 help-icon" onClick={open} />}
            </div>
            <HelpPanel show={show} close={close} category={category} />
        </>;
    };

    export default Help;